import React from 'react'
import { Trans } from '@lingui/macro'
import { ButtonOutline } from 'front-end/src/components'

import IconPlus2 from '../../../../components/common/icon/IconPlus2'

interface Props {
  entityName: string
  onAdd: () => void
}

export const EmptyList = ({ onAdd, entityName }: Props) => {
  return (
    <div className="ItemsPane__noItems">
      <div className="ItemsPane__noItems__label">
        <Trans>No {entityName} yet?</Trans>
      </div>
      <ButtonOutline onClick={onAdd} leftIcon={<IconPlus2 />}>
        <Trans>Add</Trans> {entityName}
      </ButtonOutline>
    </div>
  )
}
